/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Role } from "../models/ui/role.model";
import { AuthorizationService } from "../services/authorization.service";
import { PATHS } from "../utils/constants";

export const adminGuard: CanActivateFn = () => {
	const authorizationService = inject(AuthorizationService);
	const router = inject(Router);

	if (authorizationService.hasRole(Role.ADMIN)) return true;
	else {
		router.navigate([PATHS.DASHBOARD]);
		return false;
	}
};
